import { styled } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import themes from 'styles/themes';

export interface IPrimaryButton {
    padding?: string;
    bgcolor?: string;
    color?: string;
    fontWeight?: number;
    size?: number;
    margin?: string | number;
    radius?: number;
    hoverbackground?: string;
    hovercolor?: string;
    border?: string;
}

export const PrimaryButton = styled(Button)((props: IPrimaryButton) => ({
    width: '100%',
    padding: props.padding || '18px 32px',
    display: 'inline',
    background: props.bgcolor || themes.palette.primary.main,
    color: props.color || '#f2f2f2',
    fontStyle: 'normal',
    fontWeight: props.fontWeight || 500,
    fontSize: props.size || 16,
    fontFamily: 'PoppinsRegular',
    margin: props.margin || 0,
    border: props.border || 'none',
    textTransform: 'uppercase',
    borderRadius: props.radius || 98,
    '&:hover ': {
        background: props.hoverbackground || '#1a1a1abf',
        color: props.hovercolor || '#f2f2f2',
    },
}));
